import ContactPreferenceContainer from './ContactPreferenceContainer';

export default ContactPreferenceContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/ContactPreference/index.js